import { render, staticRenderFns } from "./morf.vue?vue&type=template&id=2d5ea3dc&scoped=true&"
import script from "./morf.vue?vue&type=script&lang=js&"
export * from "./morf.vue?vue&type=script&lang=js&"
import style0 from "./morf.vue?vue&type=style&index=0&id=2d5ea3dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5ea3dc",
  null
  
)

export default component.exports